// Messages API service using Cloudflare Worker
class MessagesAPI {
  constructor() {
    this.workerUrl = import.meta.env.VITE_MESSAGES_API_URL || 'https://oxygen-gym-messages-api.your-subdomain.workers.dev'
  }

  async create(messageData) {
    try {
      const response = await fetch(this.workerUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(messageData)
      })

      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.error || 'Failed to send message')
      }

      return data.data
    } catch (error) {
      console.error('Messages API Error:', error)
      throw error
    }
  }

  // For admin panel - get all messages (using service role)
  async getAll() {
    try {
      // For now, use direct Supabase connection for admin
      // In future, we can create admin endpoints in the worker
      const { supabase } = await import('../config/supabase.js')
      const { data, error } = await supabase
        .from('messages')
        .select('*')
        .order('created_at', { ascending: false })

      if (error) throw error
      return data
    } catch (error) {
      console.error('Messages API Error:', error)
      throw error
    }
  }

  // For admin panel - mark as read
  async markAsRead(messageId, authToken) {
    try {
      const response = await fetch(`${this.workerUrl}/admin/messages/${messageId}/read`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json',
        }
      })

      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.error || 'Failed to update message')
      }

      return data.data
    } catch (error) {
      console.error('Messages API Error:', error)
      throw error
    }
  }
}

export const messagesAPI = new MessagesAPI()